module.exports = __webpack_public_path__ + "5dfe8ceb80421ec835dd09cebe579d77.svg";